import request from '../request'

/**
 * 设计修改通知单相关接口
 * 从 cosystem-portal 同步过来的入口，本仓暂未启用对应后端，使用前请核对 URL。
 */

export function updateDesignChange(data) {
    return request({
        url: '/project-service/cosys/design/change/update',
        method: 'POST',
        data
    })
}

export function addDesignChange(data) {
    return request({
        url: '/project-service/cosys/design/change/add',
        method: 'POST',
        data
    })
}

export function fetchDesignChangeDetail(id) {
    return request({
        url: `/project-service/cosys/design/change/detail/${id}`,
        method: 'GET'
    })
}

export function fetchDesignChangeList(params) {
    return request({
        url: '/project-service/cosys/design/change/list',
        method: 'GET',
        params
    })
}

export function getDesignPlanPersonnel(params) {
    return request({
        url: '/project-service/cosys/design/plan/personnel',
        method: 'GET',
        params
    })
}

export function exportDesignChange(id) {
    return request({
        url: `/project-service/cosys/design/change/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}

export function resubmitDesignChange(data) {
    return request({
        url: '/project-service/cosys/design/change/resubmit',
        method: 'POST',
        data
    })
}
